import React from 'react';

import PluridIcon from '../../PluridIcon';

import {
    PluridIconProperties,
} from '../../interfaces';



const PluridIconHighlight: React.FC<PluridIconProperties> = (
    properties,
) => {
    return (
        <PluridIcon
            {...properties}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
                <path d="M768.14,44.64C759.76,50,255.53,500.19,255.53,502.18c0,3,227.88,231.27,229.87,230.07,3.39-2.19,450.75-505.62,455.74-513,5.19-7.79,6.39-19.95,2.79-29.94-2.4-6.38-135.69-141.07-144.06-145.45C792.28,39.86,774.53,40.25,768.14,44.64Z" />
                <path d="M209.24,545.28l-13.37,13.57,8.19,10c16,19.75,27.34,51.27,27.53,76.42,0,16.56-5.58,39.91-13.57,56.27-5.79,11.77-12,19.75-29.13,37.51l-22,22.54,29.34,29.34L225.4,820,248,798.09c17.36-17,25.94-23.74,36.9-29.14,43.7-22,93.59-16.76,132.5,13.37l11.17,8.77,13.77-14,13.77-13.77L340.34,647.64C276.69,584,224.2,531.91,223.61,531.91S216.42,537.89,209.24,545.28Z" />
                <path d="M95.11,833.6,54,876.1l57.27.6,57.47.41,13.37-13.38,13.57-13.57-29.53-29.53L136.41,790.9Z" />
                <path d="M52,939v19.95h816.1V919H52Z" />
            </svg>
        </PluridIcon>
    );
}


export default PluridIconHighlight;
